var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMycards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,4 L21,4 C21.55,4 22,4.45 22,5 L22,19 C22,19.55 21.55,20 21,20 L3,20 C2.45,20 2,19.55 2,19 L2,5 C2,4.45 2.45,4 3,4 Z",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,6 L19,6 C19.55,6 20,6.45 20,7 L20,17 C20,17.55 19.55,18 19,18 L5,18 C4.45,18 4,17.55 4,17 L4,7 C4,6.45 4.45,6 5,6 Z",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    transform: "translate(12, 12) rotate(15) translate(-12, -12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7,8 L17,8 C17.55,8 18,8.45 18,9 L18,15 C18,15.55 17.55,16 17,16 L7,16 C6.45,16 6,15.55 6,15 L6,9 C6,8.45 6.45,8 7,8 Z",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    transform: "translate(12, 12) rotate(30) translate(-12, -12)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMycards);
export default __webpack_public_path__ + "static/media/mycards.4369739be72d344512a064bcf84ccad4.svg";
export { ForwardRef as ReactComponent };